export const dragCollect = monitor => ({ isDragging: monitor.isDragging() });

export const dropCollect = monitor => {
  const item = monitor.getItem();
  return {
    isDropOnEmptyArea: item && item.isDropOnEmptyArea,
    isOver: monitor.isOver({ shallow: true }),
    canDrop: monitor.canDrop(),
  };
};
